<template>
<div>
    <section>
        <div class="top-nav-div">
            <div class="top-nav-elements">
                <a href="#" class="link-block-42 w-inline-block"><img sizes="(max-width: 1000px) 100vw, 1000px" srcset="@/assets/images/NewSelf_Logo-p-500.webp 500w, @/assets/images/NewSelf_Logo-p-800.webp 800w, @/assets/images/NewSelf_Logo.webp 1000w" alt="" src="@/assets/images/NewSelf_Logo.webp" loading="lazy" class="image-294"></a>
                <div class="form-nav-div" :class="{ 'has-back-button': active_el > 1 }">
                    <a href="#" @click.prevent="GoBack()" class="back-link w-inline-block" :style="{ visibility: active_el === 1 ? 'hidden' : 'visible' }">
                        <div class="text-block-507">&lt;-</div>
                    </a>
                    <div class="form-progress-div">
                        <div>
                            <div class="text-block-508">Pre-Qualify</div>
                        </div>
                        <div class="form-precent-div">
                            <div class="text-block-509"><strong>1. Basic Info</strong> </div>
                        </div>
                    </div>
                    <div class="back-link-spacer"></div>
                </div>
                <div class="div-block-1442">
                </div>
            </div>
        </div>
    </section>

    <div>
        <div class="enroll-div-wrap">
            <div class="enroll-slide-2" v-if="active_el === 1">
                <div class="question-container questions-div-phone-new">
                    <div class="w-form">
                        <form @submit.prevent="handleSubmit" id="email-form-2" name="email-form-2" data-name="Email Form 2" method="get">
                            <div class="form-hero-div" style="padding-top: 0%;">
                                <img sizes="100vw" srcset="@/assets/images/stepsimage_teledoc_nS-p-500.webp 500w, @/assets/images/stepsimage_teledoc_nS.webp 641w" alt="" src="@/assets/images/stepsimage_teledoc_nS.webp" loading="lazy" class="enroll-top-image">
                                <div class="enroll-header">Lose More. Pay Less.</div>
                                <p class="formhero-sub">Fill out a few questions to make sure we can support you in your weight loss journey. <strong>Please answer accurately.</strong></p>

                                <div class="form-3-things-div">
                                    <div class="form-box-div">
                                        <div class="div-block-960 new">
                                            <div class="div-block-976 addons">
                                                <div class="div-block-974">
                                                    <div class="form-product-div">
                                                        <img src="@/assets/images/checkout_quiz.webp" loading="lazy" sizes="(max-width: 1080px) 100vw, 1080px" srcset="@/assets/images/checkout_quiz-p-500.webp 500w, @/assets/images/checkout_quiz-p-800.webp 800w, @/assets/images/checkout_quiz.webp 1080w" alt="" class="icon-img-copy _2">
                                                    </div>
                                                </div>
                                                <div>
                                                    <div class="product-name-2-copy">Pre-Qualify in Minutes<br></div>
                                                    <div class="text-block-850">Answer a few simple questions.</div>
                                                </div>
                                            </div>
                                            <div class="text-block-141 new">$348</div>
                                            <div class="div-block-1778">
                                                <img src="@/assets/images/icon_check_green.svg" loading="lazy" alt="" class="image-602">
                                            </div>
                                        </div>
                                        <a href="#" class="link-block-66 w-inline-block"></a>
                                    </div>
                                    <div class="form-box-div">
                                        <div class="div-block-960 new">
                                            <div class="div-block-976 addons">
                                                <div class="div-block-974">
                                                    <div class="form-product-div">
                                                        <img src="@/assets/images/checkout_checkup.webp" loading="lazy" sizes="(max-width: 1080px) 100vw, 1080px" srcset="@/assets/images/checkout_checkup-p-500.webp 500w, @/assets/images/checkout_checkup-p-800.webp 800w, @/assets/images/checkout_checkup.webp 1080w" alt="" class="icon-img-copy _2">
                                                    </div>
                                                </div>
                                                <div>
                                                    <div class="product-name-2-copy">Online Doctor Review<br></div>
                                                    <div class="text-block-850">Board Certified Doctors are ready.</div>
                                                </div>
                                            </div>
                                            <div class="text-block-141 new">$348</div>
                                            <div class="div-block-1778">
                                                <img src="@/assets/images/icon_check_green.svg" loading="lazy" alt="" class="image-602">
                                            </div>
                                        </div>
                                        <a href="#" class="link-block-66 w-inline-block"></a>
                                    </div>
                                    <div class="form-box-div">
                                        <div class="div-block-960 new">
                                            <div class="div-block-976 addons">
                                                <div class="div-block-974">
                                                    <div class="form-product-div ship">
                                                        <img src="@/assets/images/HIW_Deliver.webp" loading="lazy" sizes="(max-width: 1080px) 100vw, 1080px" srcset="@/assets/images/HIW_Deliver-p-500.webp 500w, @/assets/images/HIW_Deliver-p-800.webp 800w, @/assets/images/HIW_Deliver.webp 1080w" alt="" class="icon-img-copy ship">
                                                    </div>
                                                </div>
                                                <div>
                                                    <div class="product-name-2-copy">Free Next Day Shipping</div>
                                                    <div class="text-block-850">Cold Packed and at your door.</div>
                                                </div>
                                            </div>
                                            <div class="text-block-141 new">$348</div>
                                            <div class="div-block-1778">
                                                <img src="@/assets/images/icon_check_green.svg" loading="lazy" alt="" class="image-602">
                                            </div>
                                        </div>
                                        <a href="#" class="link-block-66 w-inline-block"></a>
                                    </div>
                                </div>
                                <div class="form-disclaimer-div" style="margin-bottom: 0px;">
                                    <label class="w-checkbox enroll-checkbox-field" :class="{ 'field-error': fieldErrors.agreed_to_terms }">
                                        <input type="checkbox" v-model="people.agreed_to_terms" required name="checkbox-tos" id="checkbox-tos" data-name="Checkbox TOS" class="w-checkbox-input enroll-checkbox top">
                                        <span class="enroll-checkbox-label w-form-label" for="checkbox-tos">
                                            I Agree to NewSelf's
                                            <a href="https://newself.com/terms-of-use" target="_blank" class="enroll-checkbox-link">Terms</a>,
                                            <a href="https://newself.com/privacy-policy" target="_blank" class="enroll-checkbox-link">Privacy Policy</a>
                                            and consent to
                                            <a href="https://newself.com/telehealth-consent" target="_blank" class="enroll-checkbox-link">Telehealth</a>
                                        </span>
                                    </label>
                                </div>
                                <div class="enroll-form-button-div">
                                    <input type="submit" data-wait="Please wait..." class="enroll-form-submit-button top w-button" value="Start my FREE visit ->">
                                </div>

                            </div>
                        </form>
                        <div class="w-form-done">
                            <div>Thank you! Your submission has been received!</div>
                        </div>
                        <div class="w-form-fail">
                            <div>Oops! Something went wrong while submitting the form.</div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Step 2: Personal Info -->
            <div class="enroll-slide-2" v-if="active_el==2">
                <div class="enroll-form-header-div">
                    <div class="enroll-form-header-text">Let&#x27;s start with the Basics</div>
                </div>
                <div class="enroll-form-block update w-form">
                    <form id="email-form" name="email-form" data-name="Email Form" @submit.prevent="handleSubmit" class="enroll-form update">
                        <h1 class="enroll-form-question-text smaller a">Let's make sure we are licensed in your state</h1>
                        <WeightLossStatePicker
                            v-model="people.state"
                            :error="!!fieldErrors.state"
                        />
                        <div v-if="formErrors.state" class="email-check-error state-picker-error">{{ formErrors.state }}</div>
                        <h1 class="enroll-form-question-text smaller a">Who do I have the pleasure of talking to?</h1>
                        <div class="enroll-form-field-wrap-div update"><input v-model="people.first_name" class="text-field-33 update w-input" maxlength="256" name="name" data-name="Name" placeholder="First Name" type="text" id="name" required><input v-model="people.last_name" class="text-field-33 update w-input" maxlength="256" name="Last-name" data-name="Last Name" placeholder="Last Name" type="text" id="Last-name" required></div>
                        <h1 class="enroll-form-question-text smaller">What was your gender at birth?</h1>
                        <div class="div-block-1893"><label class="w-checkbox checkbox-field-18 male"><input type="checkbox" :checked="people.gender === 'Male'" @change="handleGenderSelection('Male')" name="checkbox-4" id="checkbox-male" data-name="Checkbox 4" class="w-checkbox-input enroll-checkbox"><span class="checkbox-label-15 w-form-label" for="checkbox-male">Male</span></label><label class="w-checkbox checkbox-field-18 female"><input type="checkbox" :checked="people.gender === 'Female'" @change="handleGenderSelection('Female')" name="checkbox-4" id="checkbox-female" data-name="Checkbox 4" class="w-checkbox-input enroll-checkbox"><span class="checkbox-label-15 w-form-label" for="checkbox-female">Female</span></label></div>
                        <div v-if="formErrors.gender" class="gender-error">{{ formErrors.gender }}</div>
                        <h1 class="enroll-form-question-text smaller">Please enter your email</h1><input v-model="people.email" @blur="checkEmailOnBlur" class="text-field-33 email form update w-input" :class="{ 'email-error-highlight': emailCheckError }" maxlength="256" name="Email-2" data-name="Email 2" placeholder="Enter your email" type="email" id="Email-2" required>
                        <div v-if="emailCheckError" class="email-check-error">{{ emailCheckError }}</div>
                       
                        <h1 class="enroll-form-question-text smaller">Please enter your mobile number</h1>
                        
                        <input v-model="people.phone" :class="{ 'field-error': formErrors.phone }" class="text-field-33 email form update w-input" maxlength="16" data-name="Phone" placeholder="(XXX) XXX-XXXX" type="text" autocomplete="off" inputmode="numeric" @input="handlePhoneInput" @keypress="enforceNumericOnly" @paste="sanitizePaste" required>
                        <div v-if="formErrors.phone" class="phone-input-error">{{ formErrors.phone }}</div>
                        <div class="sms-consent-row" :class="{ 'sms-consent-shake': smsConsentShake, 'sms-consent-row-error': smsConsentError }">
                            <input type="checkbox" id="checkbox-sms" name="checkbox-sms" class="sms-consent-checkbox" v-model="people.agree_to_phone" @change="smsConsentError = ''">
                            <label for="checkbox-sms" class="sms-phone-disclaimer">By checking the box, you agree that NewSelf can contact you at the telephone number provided using an autodialer, AI technology, artificial voice and prerecorded calls or text/SMS messages with information and offers. Msg. and data rates apply. You also agree to our <a href="https://www.newself.com/privacy-policy" target="_blank" class="sms-phone-disclaimer-link" @click.stop>Privacy Policy</a> and <a href="https://newself.com/terms-of-use" target="_blank" class="sms-phone-disclaimer-link" @click.stop>Terms</a>.</label>
                        </div>

                        <div class="sms-actions">
                            <div v-if="smsConsentError" class="sms-consent-error">{{ smsConsentError }}</div>
                            <button type="submit" class="enroll-form-submit-button top w-button" :disabled="isCheckingEmail">
                                <span v-if="isCheckingEmail">Please wait...</span>
                                <span v-else>Next -&gt;</span>
                            </button>
                        </div>
                    </form>
                    <div class="w-form-done">
                        <div>Thank you! Your submission has been received!</div>
                    </div>
                    <div class="w-form-fail">
                        <div>Oops! Something went wrong while submitting the form.</div>
                    </div>
                </div>

            </div>
            <div class="enroll-slide-2" v-if="active_el === 3">
                <div class="question-div-2">
                    <div class="text-block-513">What is your date of birth?</div>
                    <div class="form-subs">Based on your date of birth our doctors can prescribe the proper prescription.</div>
                    <div class="felix-form-block w-form">
                        <form @submit.prevent="validateDOB" id="email-form" name="email-form" data-name="Email Form" method="get">
                            <div class="div-block-1470 mobile-entry form _2 birth">
                                <select v-model="people.dob.mm" id="birth-month-2" name="birth-month-2" data-name="Birth Month 2" class="select-field-5 felix w-select dob-sel-one" :class="{ 'field-error': fieldErrors.dob_mm }" @change="handleDOBMonthChange" required>
                                    <option value="">Month</option>
                                    <option value="01">January</option>
                                    <option value="02">February</option>
                                    <option value="03">March</option>
                                    <option value="04">April</option>
                                    <option value="05">May</option>
                                    <option value="06">June</option>
                                    <option value="07">July</option>
                                    <option value="08">August</option>
                                    <option value="09">September</option>
                                    <option value="10">October</option>
                                    <option value="11">November</option>
                                    <option value="12">December</option>
                                </select>
                                <div class="text-block-518">-</div>
                                <input class="phone-number-field-3 form birth felix w-input" :class="{ 'field-error': fieldErrors.dob_dd }" maxlength="2" pattern="[0-9]*" inputmode="numeric" v-model="people.dob.dd" name="birth-day-2" data-name="Birth Day 2" placeholder="Day" type="text" id="birth-day-2" @input="handleDOBDayInput($event, maxDobDay)" required>
                                <div class="text-block-518">-</div>
                                <input class="phone-number-field-3 _2 form birth felix w-input" :class="{ 'field-error': fieldErrors.dob_yyyy }" pattern="[0-9]*" inputmode="numeric" maxlength="4" v-model="people.dob.yyyy" name="birth-year-2" data-name="Birth Year 2" placeholder="Year" type="text" id="birth-year-2" @input="validateNumericInput($event)" required>
                            </div>
                            <div v-if="isError" class="error-message" style="color: red; margin-top: 10px; font-size: 14px;">
                                Please enter a valid date of birth. You must be at least 18 years old.
                            </div>
                            <input type="submit" data-wait="Please wait..." class="form-button w-button" value="Next ->">
                        </form>
                        <div class="w-form-done">
                            <div>Thank you! Your submission has been received!</div>
                        </div>
                        <div class="w-form-fail">
                            <div>Oops! Something went wrong while submitting the form.</div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="enroll-slide-2" v-if="active_el==4">
                <div class="question-div-2">
                    <div class="text-block-513">What is your height and weight?</div>
                    <div class="form-subs">We'll use this to determine your Body mass Index (BMI) for diagnosis. remember, BMI is a measure of size - not health</div>
                    <div class="felix-form-block w-form">
                        <form @submit.prevent="handleSubmit">
                            <div class="height-weight-fields">
                                <div class="height-row">
                                    <div class="input-with-unit">
                                        <input v-model="people.height.foot" name="feet" autocomplete="on" class="quiz-input-field" :class="{ 'field-error': formErrors.height }" placeholder="Feet" maxlength="1" type="text" id="feet" pattern="[0-9]*" inputmode="numeric" @input="handleFeetInput($event, 8)" required>
                                        <span class="input-unit">ft.</span>
                                    </div>
                                    <div class="input-with-unit">
                                        <input v-model="people.height.inches" name="inches" autocomplete="on" class="quiz-input-field" :class="{ 'field-error': formErrors.height }" placeholder="Inches" maxlength="2" type="text" id="inches" pattern="[0-9]*" inputmode="numeric" @input="handleInchesInput($event, 11)" required>
                                        <span class="input-unit">in.</span>
                                    </div>
                                </div>
                                <div class="input-with-unit">
                                    <input v-model="people.weight" name="weight-2" autocomplete="on" class="quiz-input-field full-width" :class="{ 'field-error': formErrors.weight }" placeholder="Weight" maxlength="3" type="text" id="weight-2" pattern="[0-9]*" inputmode="numeric" @input="validateNumericInput($event)" required>
                                    <span class="input-unit">lbs.</span>
                                </div>
                                <div class="bmi-div" v-if="bmi_calculated"><img src="@/assets/images/icon_info.svg" loading="lazy" alt="" class="image-686">
                                    <div class="bmi-text">Your BMI Score is {{ bmi_calculated }}</div>
                                </div>
                                <div v-if="formErrors.height" class="error-message">
                                    {{ formErrors.height }} (Inches must be 0-11)
                                </div>
                                <div v-if="formErrors.weight" class="error-message">
                                    {{ formErrors.weight }}
                                </div>
                                <input type="submit" data-wait="Please wait..." class="form-button w-button" value="Next -&gt;">
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div class="enroll-slide-2" v-if="active_el==5">
                <div class="question-div-2">
                    <div class="text-block-513">What is your <strong>desired weight</strong>?</div>
                    <div class="felix-form-block w-form">
                        <form @submit.prevent="finalSubmit">
                            <div class="height-weight-fields">
                                <div class="input-with-unit">
                                    <input v-model="people.desired_weight" name="Goal-Weight" autocomplete="on" class="quiz-input-field full-width" :class="{ 'field-error': formErrors.desiredWeight }" placeholder="Goal weight" type="text" id="Goal-Weight" pattern="[0-9]*" inputmode="numeric" @input="validateNumericInput($event)" required>
                                    <span class="input-unit">lbs.</span>
                                </div>
                                <div v-if="formErrors.desiredWeight" class="error-message">
                                    {{ formErrors.desiredWeight }}
                                </div>
                                <button type="submit" class="form-button w-button" :disabled="isSubmitting">
                                    <span v-if="isSubmitting">
                                        <svg xmlns="http://www.w3.org/2000/svg" style="margin: auto; background: none; display: block;" width="15px" height="15px" viewBox="0 0 100 100">
                                            <circle cx="50" cy="50" fill="none" stroke="white" stroke-width="10" r="35" stroke-dasharray="164.93361431346415 56.97787143782138">
                                                <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="0.53475935828877s" values="0 50 50;360 50 50" keyTimes="0;1"></animateTransform>
                                            </circle>
                                        </svg>
                                    </span>
                                    <span v-else>Next -&gt;</span>
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Consent Modal -->

    <!-- Paid User Modal -->
    <PaidUserModal
        :visible="showPaidUserModal"
        :email="people.email"
        :reason="paidUserReason"
        :role="paidUserRole"
        @close="showPaidUserModal = false" />
</div>
</template>

<script>
import state from "@/utils/state.json"
import { cleanUsPhone, formatUsPhone, isValidUsPhone } from '@/utils/phone'
import {
    mapActions
} from 'vuex'
import { checkEmail, isValidEmailFormat } from '@/utils/checkEmail';
import PaidUserModal from '../common/PaidUserModal.vue';
import WeightLossStatePicker from './WeightLossStatePicker.vue';
import { offerQuery } from '@/utils/freeNadLifeOffer.js';
export default {
    name: 'WeightLossForm2',
    components: {
        PaidUserModal,
        WeightLossStatePicker
    },
    data() {
        return {
            allState: state,
            baseUrl: process.env.VUE_APP_API_ENDPOINT,
            appName: process.env.VUE_APP_COMPANY,
            appMainWeb: process.env.VUE_APP_HOMEPAGE,
            active_el: 1,
            tempvalue: '',
            formErrors: {},
            fieldErrors: {},
            smsConsentError: '',
            smsConsentShake: false,
            isSubmitting: false,
            isError: false,
            emailCheckError: '',
            isCheckingEmail: false,
            showPaidUserModal: false,
            paidUserReason: 'paid_user',
            paidUserRole: '',

            people: {
                first_name: '',
                last_name: '',
                email: '',
                phone: '',
                heightInInches: '',
                height: {
                    foot: '',
                    inches: ''
                },
                weight: '',
                bmi: '',
                gender: '',
                agreed_to_text: "Yes",
                agree_to_phone: false,
                desired_weight: '',
                state: '',
                agreed_to_terms: true,
                form_step2_agree: true,
                dobMMDDYYYY: 'NA',
                source_web: 2,
                ip_address: '',
                age: '',
                tracking_session_id: '',
                user_agent: '',
                dob: {
                    mm: '',
                    dd: '',
                    yyyy: ''
                },
            },
            showConsentModal: false,
            consentModalType: 'terms'
        }
    },
    async mounted() {
        // NEW: Detect redirect source from quiz
        this.detectQuizSource();

        if (this.$route.query.sema) {
            await this.$store.dispatch('addSemaOffer', this.$route.query.sema);
        }
        if (this.$route.query.tir) {
            await this.$store.dispatch('addTirOffer', this.$route.query.tir);
        }

        const requestedStep = parseInt(this.$route.query.step);
        if (requestedStep >= 1 && requestedStep <= 5) {
            this.active_el = requestedStep;
        }

        this.getIpAddress();
    },
    computed: {
        maxDobDay() {
            const mm = this.people.dob.mm;
            const yyyy = this.people.dob.yyyy;
            if (!mm) return 31;
            const m = parseInt(mm);
            if ([4, 6, 9, 11].includes(m)) return 30;
            if (m === 2) {
                const y = parseInt(yyyy);
                if (!y || String(yyyy).length < 4) return 29;
                return (y % 4 === 0 && (y % 100 !== 0 || y % 400 === 0)) ? 29 : 28;
            }
            return 31;
        },
        bmi_calculated() {
            const heightInInches = (parseInt(this.people.height.foot) * 12) + parseInt(this.people.height.inches);
            const weightInPounds = parseInt(this.people.weight);
            if (heightInInches && weightInPounds) {
                return ((weightInPounds * 703) / (heightInInches * heightInInches)).toFixed(2);
            }
            return "";
        },
        isFormErrorEmpty() {
            return Object.keys(this.formErrors).length === 0;
        },
        isValidPhone() {
            // Valid 10-digit US number, ignoring an optional leading 1 country code
            return isValidUsPhone(this.people.phone);
        },
        isValidEmail() {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emailRegex.test(this.people.email);
        },
        calculatedBMI() {
            if (this.people.weight && this.people.heightInInches) {
                const heightInInches = parseFloat(this.people.heightInInches);
                const weightInPounds = parseFloat(this.people.weight);
                return (weightInPounds / (heightInInches * heightInInches)) * 703;
            }
            return null;
        },
        isNyNjState() {
            const state = this.people.state;
            return ['NY', 'NJ', 'New York', 'New Jersey'].includes(state);
        },
        stateConsentName() {
            const state = this.people.state;
            if (state === 'NY' || state === 'New York') {
                return 'New York Consent for Weight Loss Treatment';
            }
            if (state === 'NJ' || state === 'New Jersey') {
                return 'New Jersey Consent for Weight Loss Treatment';
            }
            return 'State Consent';
        }
    },
    methods: {
        ...mapActions([
            'setCartVisibility'
        ]),

        detectQuizSource() {
            let quizSourceData = null;

            // 1. Try sessionStorage
            const ssData = sessionStorage.getItem('quiz_redirect_source');
            if (ssData) {
                try {
                    quizSourceData = JSON.parse(ssData);
                    console.log('Quiz source detected from sessionStorage:', quizSourceData);
                } catch(e) {
                    console.error('Failed to parse sessionStorage source:', e);
                }
            }

            // 2. Try URL query params
            if (!quizSourceData && this.$route.query.from === 'glp1-v3') {
                quizSourceData = {
                    from_route: '/glp1-v3',
                    q5_answer: this.$route.query.q5 === 'no' ? 'No, I am not currently taking GLP Medication' : 'Yes, I am taking GLP Medication',
                    source: 'query_params',
                    timestamp: parseInt(this.$route.query.ts) || null
                };
                console.log('Quiz source detected from URL query params:', quizSourceData);
            }

            this.quizSourceData = quizSourceData;
        },

        // Consent modal methods
        openConsentModal(type) {
            this.consentModalType = type;
            this.showConsentModal = true;
        },

        closeConsentModal() {
            this.showConsentModal = false;
        },

        async checkEmailOnBlur() {
            this.emailCheckError = '';
            if (!this.people.email || !isValidEmailFormat(this.people.email)) {
                return;
            }
            this.isCheckingEmail = true;
            try {
                const result = await checkEmail(this.people.email);
                if (!result.proceed) {
                    if (result.reason === 'paid_user') {
                        this.paidUserReason = 'paid_user';
                        this.paidUserRole = '';
                        this.showPaidUserModal = true;
                        this.emailCheckError = 'This email already has a paid account.';
                    } else if (result.reason === 'wrong_role') {
                        this.paidUserReason = 'wrong_role';
                        this.paidUserRole = result.role || '';
                        this.showPaidUserModal = true;
                        this.emailCheckError = `Access denied. Account role (${result.role}) is not authorized.`;
                    }
                }
            } catch (e) {
                // Never block on error
            } finally {
                this.isCheckingEmail = false;
            }
        },
        async handleEmailCheck() {
            this.emailCheckError = '';
            if (!isValidEmailFormat(this.people.email)) {
                return true;
            }
            this.isCheckingEmail = true;
            try {
                const result = await checkEmail(this.people.email);
                if (!result.proceed) {
                    if (result.reason === 'paid_user') {
                        this.paidUserReason = 'paid_user';
                        this.paidUserRole = '';
                        this.showPaidUserModal = true;
                        this.emailCheckError = 'This email already has a paid account.';
                    } else if (result.reason === 'wrong_role') {
                        this.paidUserReason = 'wrong_role';
                        this.paidUserRole = result.role || '';
                        this.showPaidUserModal = true;
                        this.emailCheckError = `Access denied. Account role (${result.role}) is not authorized.`;
                    }
                    return false;
                }
                return true;
            } catch (e) {
                return true;
            } finally {
                this.isCheckingEmail = false;
            }
        },

        // Field error methods
        setFieldError(field) {
            this.$set(this.fieldErrors, field, true);
        },

        clearFieldError(field) {
            this.$delete(this.fieldErrors, field);
        },

        async getIpAddress() {
            try {
                const response = await fetch('https://api.ipify.org?format=json');
                const data = await response.json();
                this.people.ip_address = data.ip;
                return data.ip;
            } catch (error) {
                console.error('Error getting IP:', error);
            }
        },
        GoBack() {
            if (this.active_el > 1) {
                this.active_el--;
            }
        },
        isValidDate(month, day, year) {
            const monthNum = parseInt(month);
            const dayNum = parseInt(day);
            const yearNum = parseInt(year);

            // Check for valid numeric values
            if (isNaN(monthNum) || isNaN(dayNum) || isNaN(yearNum)) {
                return false;
            }

            // Check ranges before creating date
            if (monthNum < 1 || monthNum > 12) return false;
            if (dayNum < 1 || dayNum > 31) return false;
            if (yearNum < 1900 || yearNum > new Date().getFullYear()) return false;

            const date = new Date(yearNum, monthNum - 1, dayNum);
            const today = new Date();

            // Check if the date is valid (handles things like Feb 30, etc.)
            if (date.getMonth() !== monthNum - 1 ||
                date.getDate() !== dayNum ||
                date.getFullYear() !== yearNum) {
                return false;
            }

            // Ensure the date is not in the future
            if (date > today) {
                return false;
            }

            return true;
        },
        calculateAge(month, day, year) {
            const today = new Date();
            const birthDate = new Date(year, month - 1, day);
            let age = today.getFullYear() - birthDate.getFullYear();
            const monthDiff = today.getMonth() - birthDate.getMonth();

            if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
                age--;
            }

            return age;
        },
        validateDOB() {
            this.fieldErrors = {};
            const {
                mm,
                dd,
                yyyy
            } = this.people.dob;

            // Check if all fields are filled
            if (!mm) {
                this.fieldErrors.dob_mm = true;
            }
            if (!dd) {
                this.fieldErrors.dob_dd = true;
            }
            if (!yyyy) {
                this.fieldErrors.dob_yyyy = true;
            }

            if (Object.keys(this.fieldErrors).length > 0) {
                this.isError = true;
                return;
            }

            // Validate the actual date
            if (!this.isValidDate(mm, dd, yyyy)) {
                this.fieldErrors.dob_mm = true;
                this.fieldErrors.dob_dd = true;
                this.fieldErrors.dob_yyyy = true;
                this.isError = true;
                return;
            }

            // Check minimum age (18 years)
            const age = this.calculateAge(parseInt(mm), parseInt(dd), parseInt(yyyy));
            if (age < 18) {
                this.fieldErrors.dob_mm = true;
                this.fieldErrors.dob_dd = true;
                this.fieldErrors.dob_yyyy = true;
                this.isError = true;
                return;
            }

            // Format and store the date
            const paddedMonth = String(mm).padStart(2, '0');
            const paddedDay = String(dd).padStart(2, '0');
            this.people.dobMMDDYYYY = `${paddedMonth}/${paddedDay}/${yyyy}`;
            this.people.age = age;

            // Tracking will be fired in validateStep2 with other step 2 events

            this.isError = false;
            this.active_el++;
        },
        calculateBMI() {
            const heightInInches = (parseInt(this.people.height.foot) * 12) + parseInt(this.people.height.inches)
            const weightInPounds = parseInt(this.people.weight)
            this.people.bmi = (weightInPounds * 703) / (heightInInches * heightInInches)
            this.people.heightInInches = heightInInches;

        },
        updateAgreement(selectedValue) {
            // Toggle the agreement value
            this.people.agreed_to_text = this.people.agreed_to_text === selectedValue ? null : selectedValue;
        },
        triggerSmsConsentShake() {
            this.smsConsentShake = false;
            this.$nextTick(() => {
                this.smsConsentShake = true;
                setTimeout(() => {
                    this.smsConsentShake = false;
                }, 700);
            });
        },
        updateGender(selectedGender) {
            // Toggle the gender selection
            this.people.gender = this.people.gender === selectedGender ? null : selectedGender;
        },
        validateStep1() {
            this.formErrors = {};
            if (!this.people.agreed_to_terms) {
                this.formErrors.terms = 'Please agree to the terms and conditions';
                return false;
            }
            return true;
        },
        validateStep2() {

            this.formErrors = {};

            if (!this.people.state) {
                this.setFieldError('state');
                this.formErrors.state = 'Please select your state';
                return false;
            }

            if (!this.people.first_name || !this.people.last_name) {
                this.formErrors.name = 'Please enter your full name';
                return false;
            }

            if (!this.people.gender) {
                this.formErrors.gender = 'Please select your gender';
                return false;
            }

            if (!this.isValidEmail) {
                this.formErrors.email = 'Please enter a valid email address';
                return false;
            }

            if (!this.isValidPhone) {
                this.formErrors.phone = 'Please enter a valid US phone number';
                return false;
            }

            if (!this.people.agree_to_phone) {
                this.smsConsentError = 'Please agree to receive SMS communications to continue';
                this.triggerSmsConsentShake();
                return false;
            }

            // Fire tracking events for all step 2 fields with unique funnel_steps
            try {
                if (window.tracking) {
                    window.tracking.event('state', { funnel_step: 2, form: "glp_signup" });
                    window.tracking.event('sex_at_birth', { funnel_step: 3, form: "glp_signup" });
                    window.tracking.event('dob_added', { funnel_step: 4, form: "glp_signup" });
                    window.tracking.event('name_added', { funnel_step: 5, form: "glp_signup" });
                    window.tracking.event('email_complete', { funnel_step: 6, form: "glp_signup" });
                    window.tracking.event('phone_added', { funnel_step: 7, form: "glp_signup" });
                }
            } catch(error) {
                console.log(error)
            }

            return true;
        },
        validateStep3() {
            this.formErrors = {};

            const foot = parseInt(this.people.height.foot);
            const inches = parseInt(this.people.height.inches);
            const weight = parseFloat(this.people.weight);

            if (isNaN(foot) || isNaN(inches) || foot < 4 || foot > 8 || inches < 0 || inches > 11) {
                this.formErrors.height = 'Please enter a valid height';
                return false;
            }

            if (isNaN(weight) || weight < 80 || weight > 700) {
                this.formErrors.weight = 'Please enter a valid weight';
                return false;
            }

            // Calculate height in inches
            this.people.heightInInches = (foot * 12) + inches;
            // Calculate BMI
            this.people.bmi = this.calculatedBMI;

            // Fire tracking events for all step 3 fields at same funnel_step
            try {
                if (window.tracking) {
                    window.tracking.event('height', { funnel_step: 8, form: "glp_signup" });
                    window.tracking.event('current_weight', { funnel_step: 8, form: "glp_signup" });
                    window.tracking.event('bmi_confirmation', { funnel_step: 8, form: "glp_signup" });
                }
            } catch(error) {
                console.log(error)
            }

            return true;
        },

        validateStep4() {
            this.formErrors = {};

            const desiredWeight = parseFloat(this.people.desired_weight);
            const currentWeight = parseFloat(this.people.weight);

            if (isNaN(desiredWeight) || desiredWeight < 80 || desiredWeight > 700) {
                this.formErrors.desiredWeight = 'Please enter a valid desired weight';
                return false;
            }

            if (desiredWeight >= currentWeight) {
                this.formErrors.desiredWeight = 'Desired weight should be less than current weight';
                return false;
            }

            // Fire tracking event for goal weight
            try {
                if (window.tracking) {
                    window.tracking.event('goal_weight', { funnel_step: 9, form: "glp_signup" });
                }
            } catch(error) {
                console.log(error)
            }

            return true;
        },

        async handleSubmit() {
            if (["LA", "MS"].includes(this.people.state)) {
                this.$router.push({
                    name: 'leadDisqualified',
                    query: {
                        message: "Unfortunately, our GLP Medical Weight Loss program is not yet available in your state. However, we're excited to announce that it will be launching next month!"
                    }
                });
                return false;
            }
            this.formErrors = {};
            let isValid = false;

            switch (this.active_el) {
                case 1:
                    // Fire questionnaire_start on Step 1 submission
                    try {
                        if (window.tracking) {
                            await window.tracking.assertSession();
                            window.tracking.event('questionnaire_start', { funnel_step: 1, form: "glp_signup" });
                        }
                    } catch (error) {
                        console.log(error);
                    }
                    isValid = this.validateStep1();
                    break;
                case 2:
                    isValid = this.validateStep2();
                    if (isValid) {
                        const emailCheckPassed = await this.handleEmailCheck();
                        if (!emailCheckPassed) {
                            return;
                        }
                    }
                    break;
                case 3:
                    isValid = true;
                    break;
                case 4:
                    isValid = this.validateStep3();
                    break;
                case 5:
                    isValid = this.validateStep4();
                    break;
            }

            if (!isValid) {
                // Scroll to the first error so the user sees it (e.g. state at the top of the form)
                this.$nextTick(() => this.scrollToFirstError());
                return;
            }

            if (this.active_el < 5) {
                this.active_el++;
                return;
            }

            // Final submission
            this.finalSubmit();

        },
        scrollToFirstError() {
            // Scroll to the topmost error in DOM order (state, gender, etc.). The SMS-consent
            // error is intentionally excluded: it sits right by the button, so it shouldn't scroll.
            const el = this.$el.querySelector(
                '.field-error, .state-picker-error, .gender-error, .email-check-error, .error-message'
            );
            if (el) {
                el.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        },
        async finalSubmit() {
            try {
                // Validate step 4 before submission
                if (!this.validateStep4()) {
                    return false;
                }

                // Age check using calculated age instead of year comparison
                if (this.people.age < 18) {
                    this.$router.push({
                        name: 'leadDisqualified',
                        query: {
                            message: "We cannot proceed since your age is less than 18 years."
                        }
                    });
                    return false;
                }

                this.isSubmitting = true;

                // Calculate height in inches as integer
                const feet = parseInt(this.people.height.foot) || 0;
                const inches = parseInt(this.people.height.inches) || 0;
                this.people.heightInInches = (feet * 12) + inches;

                // Calculate BMI
                this.people.bmi = this.calculatedBMI;

                // Set user agent and tracking info
                this.people.user_agent = window.navigator.userAgent;
                
                // Get sessionId from tracking system (same pattern as /start route)
                // window.tracking.assertSession() maintains session internally
                let sessionId = "";
                try {
                    sessionId = await window.tracking.assertSession();
                } catch(error) {
                    if (window.trackingSessionId) {
                        sessionId = window.trackingSessionId;
                    }
                }
                if (sessionId) {
                    this.people.tracking_session_id = sessionId;
                }

                // Prepare data for submission - strip phone formatting
                const submissionData = {
                    ...this.people,
                    phone: cleanUsPhone(this.people.phone) // 10 national digits, drops leading 1 country code
                };

                const response = await this.$axios.post(`${this.baseUrl}/api/intake-form`, submissionData, {
                    headers: {
                        'Content-Type': 'application/json',
                        "Access-Control-Allow-Origin": "*"
                    }
                });

                if (response.data.status === 'success') {
                    // Fire questionnaire_end and partial with unique funnel_step
                    try {
                        if (window.tracking) {
                            window.tracking.event('questionnaire_end', { funnel_step: 10, form: "glp_signup" });
                            window.tracking.event('partial', { 
                                funnel_step: 11,
                                event_id: crypto.randomUUID(),
                                form: "glp_signup"
                            });
                        }
                    } catch(error) {
                        console.log(error)
                    }

                    this.people.id = response.data.user.id;
                    this.$store.dispatch("doLogin", response.data);
                    this.$router.push({
                        name: 'choosePlan',
                        query: {
                            'desiredWeight': this.people.desired_weight,
                            // A lander's offer link (?offer=…&nad=…) rides along to the checkout.
                            ...offerQuery(this.$route.query)
                        }
                    });
                }
            } catch (error) {
                console.error('Form submission error:', error);
                this.formErrors.submission = 'There was an error submitting your form. Please try again.';
            } finally {
                this.isSubmitting = false;
            }
        },

        handlePhoneInput(event) {
            // Format with an optional visible "1 " country code; cap to 10 digits and
            // force the displayed value so extra keystrokes can't linger past the cap.
            this.people.phone = formatUsPhone(event.target.value);
            event.target.value = this.people.phone;
            if (this.formErrors.phone) this.$delete(this.formErrors, 'phone');
        },

        enforceNumericOnly(event) {
            // Prevent any non-numeric character from being typed
            const charCode = event.which ? event.which : event.keyCode;
            // Allow control keys: backspace(8), tab(9), enter(13), arrows(37-40), delete(46)
            if (charCode === 8 || charCode === 9 || charCode === 13 || 
                (charCode >= 37 && charCode <= 40) || charCode === 46) {
                return true;
            }
            // Allow only digits 0-9
            if (charCode < 48 || charCode > 57) {
                event.preventDefault();
                return false;
            }
            return true;
        },

        sanitizePaste(event) {
            // Prevent paste and manually extract only digits
            event.preventDefault();
            const pastedText = (event.clipboardData || window.clipboardData).getData('text');
            const digitsOnly = pastedText.replace(/\D/g, '');
            
            // Insert the sanitized value
            const target = event.target;
            const maxLength = target.maxLength === 14 ? 10 : target.maxLength; // Account for formatted phone
            const finalValue = digitsOnly.slice(0, maxLength > 0 ? maxLength : digitsOnly.length);
            
            // For phone input, format the value
            if (target.id === 'phone' && finalValue.length > 0) {
                let formatted = '(' + finalValue.substring(0, 3);
                if (finalValue.length >= 4) {
                    formatted += ') ' + finalValue.substring(3, 6);
                }
                if (finalValue.length >= 7) {
                    formatted += '-' + finalValue.substring(6, 10);
                }
                target.value = formatted;
            } else {
                target.value = finalValue;
            }
            
            // Trigger input event
            const inputEvent = new Event('input', { bubbles: true });
            target.dispatchEvent(inputEvent);
        },

        validateNumericInput(event, max) {
            let value = event.target.value.replace(/\D/g, '');
            if (max !== undefined && value !== '' && parseInt(value) > max) {
                value = String(max);
            }
            if (event.target.value !== value) {
                event.target.value = value;
                event.target.dispatchEvent(new Event('input', { bubbles: true }));
            }
        },

        // Auto-focus handlers for DOB fields
        handleDOBMonthChange() {
            // Clamp day if it exceeds the new month's max
            const dd = parseInt(this.people.dob.dd);
            if (dd && dd > this.maxDobDay) {
                this.people.dob.dd = String(this.maxDobDay);
            }
            // When month is selected, focus on day field
            if (this.people.dob.mm) {
                this.$nextTick(() => {
                    const dayField = document.getElementById('birth-day-2');
                    if (dayField) dayField.focus();
                });
            }
        },

        handleDOBDayInput(event, max) {
            // First validate the input
            this.validateNumericInput(event, max);
            
            // Auto-advance when day is complete (2 digits)
            if (this.people.dob.dd && this.people.dob.dd.length === 2) {
                this.$nextTick(() => {
                    const yearField = document.getElementById('birth-year-2');
                    if (yearField) yearField.focus();
                });
            }
        },

        // Auto-focus handlers for Height/Weight fields
        handleFeetInput(event, max) {
            // First validate the input
            this.validateNumericInput(event, max);
            
            // Auto-advance when feet is complete (1 digit)
            if (this.people.height.foot && this.people.height.foot.length === 1) {
                this.$nextTick(() => {
                    const inchesField = document.getElementById('inches');
                    if (inchesField) inchesField.focus();
                });
            }
        },

        handleInchesInput(event, max) {
            // First validate the input
            this.validateNumericInput(event, max);
            
            // Auto-advance when inches is complete (2 digits)
            if (this.people.height.inches && this.people.height.inches.length === 2) {
                this.$nextTick(() => {
                    const weightField = document.getElementById('weight-2');
                    if (weightField) weightField.focus();
                });
            }
        },

        handleGenderSelection(gender) {
            this.people.gender = gender;
        }
    },
    watch: {
        calculatedBMI(newBMI) {
            this.people.bmi = newBMI;
        },
        active_el() {
            window.scrollTo(0, 0)
        },
        'people.state'() {
            this.clearFieldError('state');
            if (this.formErrors.state) this.formErrors.state = '';
        }
    }
}
</script>

<style scoped>
.questions-div-phone-new {
    max-width: 580px;
    display: flex;
    justify-content: center;
}

.sms-phone-disclaimer {
    font-size: 11px;
    line-height: 1.4;
    color: #6b7280;
    margin: -8px 0 16px;
}

.sms-phone-disclaimer-link {
    color: inherit;
    text-decoration: underline;
}

@media screen and (max-width: 768px) {
    .sms-phone-disclaimer {
        font-size: 10px;
    }
}

.enroll-form-submit-button + .enroll-disclaimer-div.form {
    margin-top: 8px;
}

.enroll-form-submit-button + .enroll-disclaimer-div.form .enroll-checkbox-field.form {
    margin-bottom: 0;
}

/* SMS consent checkbox (beside disclaimer, above Next button) */
/* position:relative anchors the absolutely-positioned .sms-consent-error below the button */
/* width:100% mirrors .enroll-form-button-div so the Next button fills the form like the other steps */
.sms-actions {
    position: relative;
    width: 100%;
}
.sms-actions .enroll-form-submit-button {
    width: 100%;
    /* .top adds margin-bottom:30px which pushed the top:100% error far below; trim it so the error sits right under the button */
    margin-bottom: 4px;
}
.sms-consent-row {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    /* phone input has 15px margin-bottom; -4px here halves the ~23px gap to ~11px */
    margin: -4px 0 0;
    padding: 8px 10px;
    border: 1px solid transparent;
    border-radius: 9px;
    transition: border-color 0.2s ease, background-color 0.2s ease;
}
.sms-consent-row .sms-phone-disclaimer {
    margin: 0;
    cursor: pointer;
    text-align: left;
}
.sms-consent-checkbox {
    flex: 0 0 auto;
    width: 20px;
    height: 20px;
    margin: 2px 0 0;
    accent-color: #205089;
    cursor: pointer;
}
.sms-consent-row-error {
    border-color: #dc3545;
    background-color: rgba(220, 53, 69, 0.05);
}
.sms-consent-error {
    position: absolute;
    left: 0;
    right: 0;
    top: 100%;
    margin: 4px 0 0;
    color: #dc3545;
    font-size: 12px;
    line-height: 1.4;
    text-align: center;
}
.sms-consent-shake {
    animation: smsConsentShake 0.6s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
}
.sms-consent-shake .sms-consent-checkbox {
    animation: smsConsentPulse 0.6s ease both;
}
@keyframes smsConsentShake {
    10%, 90% { transform: translateX(-1px); }
    20%, 80% { transform: translateX(2px); }
    30%, 50%, 70% { transform: translateX(-4px); }
    40%, 60% { transform: translateX(4px); }
}
@keyframes smsConsentPulse {
    0%, 100% { transform: scale(1); }
    30% { transform: scale(1.3); }
    60% { transform: scale(0.95); }
}


/* Center question text */
.question-div-2 .text-block-513,
.question-div-2 .form-subs {
    text-align: center !important;
}

/* Spacer to balance the back button and keep progress bar centered */
.back-link-spacer {
    width: 44px; /* Same width as back button */
    flex-shrink: 0;
}

/* Fixed centered progress bar - LARGE DESKTOP ONLY */
@media screen and (min-width: 1025px) {
    .form-nav-div {
        position: fixed !important;
        top: 15px !important;
        left: 50% !important;
        transform: translateX(-50%) !important;
        min-width: 500px !important;
        max-width: calc(100% - 40px) !important;
        z-index: 100 !important;
    }

    /* Shift right 10px when back button is visible */
    .form-nav-div.has-back-button {
        transform: translateX(calc(-50% + 25px)) !important;
    }
}

/* Mobile/Tablet header layout */
@media screen and (max-width: 1024px) {
    .top-nav-div {
        width: 100% !important;
    }

    .top-nav-elements {
        display: grid !important;
        grid-template-columns: 1fr auto !important;
        align-items: center !important;
        width: 100% !important;
        padding: 1px 1px !important;
        gap: 10px !important;
    }

    .link-block-42 {
        display: block !important;
        grid-column: 1 !important;
        justify-self: start !important;
    }

    .link-block-42 .image-294 {
        max-width: 90px !important;
        height: auto !important;
        display: block !important;
    }

    .form-nav-div {
        grid-column: 2 !important;
        justify-self: end !important;
        display: flex !important;
        align-items: center !important;
    }

    .form-progress-div {
        display: none !important;
    }

    .div-block-1442 {
        display: none !important;
    }

    .back-link {
        margin: 0 !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        padding: 8px !important;
    }

    .text-block-507 {
        font-size: 28px !important;
        line-height: 1 !important;
    }
}

@media screen and (max-width: 479px) {
    .enroll-button-copy.top {
        width: 100%;
    }

    .select-field-3.form.update {
        font-size: 16px;
    }
}
@media screen and (max-width: 479px) {
    .enroll-header {
        text-align: left;
        width: 100%;
        font-size: 32px;
        line-height: 8px;
        margin-top: 35px;
    }
    .product-name-2-copy {
        margin-bottom: 3px;
        font-size: 18px;
        font-weight: 900;
        line-height: 21px;
    }
    .enroll-checkbox-label {
        font-size: 9px;
    }
    .formhero-sub {
        text-align: left;
        width: 100%;
        margin-bottom: 30px;
        font-size: 16px;
        line-height: 20px;
        padding-top: 15px;
    }

    .enroll-form-header-text {
        width: 95%;
        font-size: 28px;
        line-height: 46px;
        margin-top: 25px;
        font-weight: bold;
    }

    .enroll-slide-2,
    .enroll-slide-3 {
        flex-direction: column;
        align-items: left;
        padding-bottom: 60px;
        display: flex;
        margin-top: 12px;
    }

    .select-field-5.felix {
        padding-left: 12px;
        font-size: 14px;
    }
}


@media screen and (max-width: 380px) {
.enroll-header {
        flex-direction: column;
        align-items: left;
        padding-bottom: 5px;
        display: flex;
        margin-top: 7px;
    }
    .form-3-things-div {
        flex-flow: column;
        align-items: flex-start;
        width: 100%;
        margin-bottom: 5px;
    }
    .formhero-sub[data-v-71c43630] {
        text-align: left;
        width: 100%;
        margin-bottom: 10px;
        font-size: 16px;
        line-height: 20px;
        padding-top: 5px;
    }
}


@media screen and (max-width: 350px) {
.enroll-header {
        font-size: 30px;
    }
    
}

input[type="text"],
input[type="number"],
input[type="tel"],
input[type="email"],
input[type="password"] {
    font-size: 16px !important;
}

.field-error {
    border-color: #ff4444 !important;
    border-width: 2px !important;
}

.error-message {
    color: #ff4444;
    font-size: 14px;
    margin-top: 10px;
    text-align: center;
}

/* Consent checkbox section styling */
.consent-section {
    margin-top: 24px;
}

.consent-section .enroll-checkbox-label {
    font-size: 14px;
    line-height: 1.5;
}

.consent-section .enroll-checkbox-link {
    color: #08466f;
    text-decoration: underline;
}

.consent-section .enroll-checkbox-link:hover {
    color: #063554;
}

/* Consistent form widths and button sizing */
.felix-form-block,
.enroll-form-block.b {
    max-width: 550px;
    margin-left: auto;
    margin-right: auto;
}

.felix-form-block .form-button,
.enroll-form-block.b .form-button {
    max-width: 550px;
    margin-left: auto;
    margin-right: auto;
    display: block;
}

/* Constrain entire form section to same width */
.question-div-2 {
    width: 100%;
    max-width: 550px;
    margin: 0 auto;
}

.question-div-2 .text-block-513 {
    text-align: left;
}

.question-div-2 .form-subs {
    text-align: left;
}

/* Height and Weight form styling */
.height-weight-fields {
    display: flex;
    flex-direction: column;
    gap: 15px;
    margin-bottom: 20px;
}

.height-row {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
}

.input-with-unit {
    position: relative;
    width: 100%;
}

.input-unit {
    position: absolute;
    right: 16px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 16px;
    color: #000;
    pointer-events: none;
}

.quiz-input-field {
    width: 100%;
    padding: 16px 50px 16px 20px;
    border: 1px solid #d9d9d9;
    border-radius: 10px;
    font-size: 16px;
    font-family: inherit;
    background: #fff;
    outline: none;
    transition: border-color 0.2s;
}

.quiz-input-field:focus {
    border-color: #08466f;
}

.quiz-input-field::placeholder {
    color: #999;
}

.email-check-error {
    color: #dc3545;
    font-size: 13px;
    /* email input has 15px margin-bottom; pull the error up so it sits ~3px under the box */
    margin-top: -12px;
}
.phone-input-error {
    color: #dc3545;
    font-size: 13px;
    /* phone input has 15px margin-bottom; pull the error up so it sits ~3px under the box */
    margin-top: -12px;
    margin-bottom: 8px;
}
.state-picker-error {
    margin-top: -32px;
    margin-bottom: 12px;
}
.gender-error {
    color: #dc3545;
    font-size: 13px;
    /* gap below buttons = label margin-bottom 15px + block margin-bottom 25px = 40px (flex, no collapse); -37px lands ~3px under */
    margin-top: -37px;
    margin-bottom: 12px;
}
.email-error-highlight {
    border-color: #dc3545 !important;
    background-color: #fff5f5 !important;
}
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
}
.modal-content {
    background: white;
    padding: 30px;
    border-radius: 12px;
    max-width: 450px;
    width: 90%;
    text-align: center;
}
.modal-content h3 {
    margin: 0 0 12px;
    font-size: 20px;
}
.modal-content p {
    margin: 0 0 24px;
    color: #555;
    font-size: 15px;
    line-height: 1.5;
}
.modal-actions {
    display: flex;
    gap: 12px;
    justify-content: center;
}
.modal-btn {
    padding: 10px 24px;
    border-radius: 8px;
    font-size: 15px;
    cursor: pointer;
    border: none;
}
.modal-btn.cancel {
    background: #e9ecef;
    color: #333;
}
.modal-btn.login {
    background: #0c9ac4;
    color: white;
}
</style>
